"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _ipdata = _interopRequireDefault(require("ipdata"));

var Locationbar = /*#__PURE__*/function () {
  function Locationbar(component) {
    (0, _classCallCheck2["default"])(this, Locationbar);
    this.dom = {
      $component: component,
      $close: Array.from(document.querySelectorAll('.js-locationbar-close')),
      $countryNodes: Array.from(component.querySelectorAll('.js-locationbar-country'))
    }, this.state = {};
    this.closeHandler = this.close.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(Locationbar, [{
    key: "mount",
    value: function mount() {
      var _this = this;

      var self = this;
      var dom = this.dom;
      console.log('Locationbar : mount', this);
      setTimeout(function () {
        if (!_this.getCookie('locationbar')) {
          _this.checkIP();
        }
      }, 300);
      dom.$close.forEach(function ($element) {
        return $element.addEventListener('click', _this.closeHandler);
      });
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this2 = this;

      var self = this;
      var dom = this.dom;
      console.log('Locationbar : unmount', this);
      dom.$close.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.closeHandler);
      });
    }
  }, {
    key: "close",
    value: function close() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('Locationbar : close', this);
      this.setCookie('locationbar', 'disabled', 14);
      document.body.classList.remove('Body--has-locationbar');
      var customEvent = new CustomEvent('updatePad');
      document.dispatchEvent(customEvent);
    }
  }, {
    key: "open",
    value: function open(country_name) {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('Locationbar : open', this);
      var showLocationbar = true;

      if (dom.$countryNodes) {
        dom.$countryNodes.forEach(function ($node) {
          return $node.innerHTML = country_name;
        });
      }

      if (dom.$component.getAttribute('data-curreny') == 'PLN') {
        if (country_name == 'United States') {
          dom.$component.querySelector(".Locationbar__lang a[data-curreny='$']").classList.add('active');
        } else if (country_name != 'Poland') {
          dom.$component.querySelector(".Locationbar__lang a[data-curreny='€']").classList.add('active');
        } else {
          showLocationbar = false;
        }
      }

      if (dom.$component.getAttribute('data-curreny') == '€') {
        if (country_name == 'United States') {
          dom.$component.querySelector(".Locationbar__lang a[data-curreny='$']").classList.add('active');
        } else if (country_name == 'Poland') {
          dom.$component.querySelector(".Locationbar__lang a[data-curreny='PLN']").classList.add('active');
          dom.$component.querySelector(".Locationbar__message[data-curreny='$']").classList.remove('active');
          dom.$component.querySelector(".Locationbar__message[data-curreny='PLN']").classList.add('active');
        } else {
          showLocationbar = false;
        }
      }

      if (dom.$component.getAttribute('data-curreny') == '$') {
        if (country_name == 'Poland') {
          dom.$component.querySelector(".Locationbar__lang a[data-curreny='PLN']").classList.add('active');
          dom.$component.querySelector(".Locationbar__message[data-curreny='$']").classList.remove('active');
          dom.$component.querySelector(".Locationbar__message[data-curreny='PLN']").classList.add('active');
        } else if (country_name != 'United States') {
          dom.$component.querySelector(".Locationbar__lang a[data-curreny='€']").classList.add('active');
        } else {
          showLocationbar = false;
        }
      }

      if (showLocationbar) {
        document.body.classList.add('Body--has-locationbar');
        var customEvent = new CustomEvent('updatePad');
        document.dispatchEvent(customEvent);
      }
    }
  }, {
    key: "checkIP",
    value: function checkIP() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      var cacheConfig = {
        max: 1000,
        // max size
        maxAge: 10 * 60 * 1000 // max age in ms (i.e. 10 minutes)

      };
      var ipdata = new _ipdata["default"]('ec3792ac4eb48f50d618741b722ad1ec906dae5ee1eaf764ff1833eb', cacheConfig);
      var country_name = this.getCookie('location_country');

      if (!country_name) {
        ipdata.lookup().then(function (info) {
          console.log('locationbar IPData check');
          self.setCookie('location_country', info.country_name, 14);
          self.open(info.country_name);
        });
      } else {
        this.open(country_name);
      }
    }
  }, {
    key: "setCookie",
    value: function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
  }, {
    key: "getCookie",
    value: function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

      return "";
    }
  }]);
  return Locationbar;
}();

exports["default"] = Locationbar;